var _g, _ellipse, _rect, _ellipse2, _ellipse3, _ellipse4, _circle, _path, _ellipse5, _rect2, _rect3, _ellipse6, _ellipse7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpacePersonInflightRed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 326,
    height: 395,
    viewBox: "0 0 326 395",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.817 264.574C149.471 236.364 164.584 215.069 179.573 217.01C194.561 218.951 203.749 243.394 200.095 271.604C196.441 299.815 181.329 321.11 166.34 319.168C151.352 317.227 142.163 292.784 145.817 264.574Z",
    fill: "#ED6A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.847 139.783C145.837 134.261 141.352 129.792 135.829 129.802L102.689 129.862C97.1665 129.872 92.6975 134.357 92.7076 139.88L92.877 232.877C92.8871 238.4 97.3724 242.869 102.895 242.859L136.035 242.798C141.558 242.788 146.027 238.303 146.017 232.78L145.847 139.783Z",
    fill: "#ED6A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.699 317.82C174.353 343.905 153.92 360.164 140.061 354.136C126.202 348.108 124.164 322.075 135.51 295.99C146.856 269.904 167.289 253.645 181.149 259.673C195.008 265.701 197.045 291.735 185.699 317.82Z",
    fill: "#ED6A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.173 145.648C216.709 173.135 190.438 188.829 180.494 180.702C170.55 172.576 180.699 143.705 203.162 116.219C225.626 88.7318 251.897 73.0374 261.841 81.1641C271.785 89.2907 261.636 118.161 239.173 145.648Z",
    fill: "#ED6A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.803 208.814C207.875 251.992 174.857 281.253 144.055 274.171C113.252 267.089 96.3302 226.345 106.258 183.166C116.186 139.988 149.204 110.727 180.006 117.809C210.809 124.891 227.731 165.636 217.803 208.814Z",
    fill: "#ED6A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.408 149.24C191.988 170.464 155.797 168.683 134.574 145.263C113.35 121.843 115.131 85.6523 138.551 64.4288C161.971 43.2053 198.162 44.9859 219.385 68.4059C240.609 91.826 238.828 128.017 215.408 149.24Z",
    fill: "#ED6A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.535 125.767C219.301 146.216 199.292 159.36 178.843 155.126C158.394 150.892 145.25 130.883 149.484 110.434C153.718 89.9853 170.516 92.3515 190.964 96.5855C211.413 100.819 227.769 105.318 223.535 125.767Z",
    fill: "#ED6A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.099 275.993C107.16 247.547 119.461 224.513 134.575 224.545C149.689 224.578 161.891 247.664 161.831 276.11C161.77 304.555 149.469 327.589 134.355 327.557C119.242 327.525 107.039 304.439 107.099 275.993Z",
    fill: "#ED6A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.221 117.121C213.324 116.579 212.969 116.055 212.426 115.951L204.353 114.411C203.81 114.307 203.286 114.663 203.183 115.205L202.723 117.614C202.62 118.156 202.976 118.68 203.518 118.783L211.592 120.324C212.134 120.428 212.658 120.072 212.761 119.529L213.221 117.121Z",
    fill: "#ED6A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.614 111.302C182.718 110.759 182.362 110.236 181.82 110.132L173.746 108.591C173.204 108.488 172.68 108.844 172.576 109.386L172.124 111.756C172.021 112.298 172.376 112.822 172.919 112.925L180.992 114.466C181.535 114.57 182.059 114.214 182.162 113.671L182.614 111.302Z",
    fill: "#ED6A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.45 318.788C154.274 346.759 138.031 367.204 123.169 364.454C108.308 361.704 100.457 336.799 105.633 308.828C110.809 280.857 127.053 260.412 141.914 263.162C156.775 265.912 164.627 290.817 159.45 318.788Z",
    fill: "#ED6A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4368 159.162C108.217 137.302 132.235 125.92 140.083 133.74C147.931 141.559 136.637 165.619 114.857 187.478C93.0764 209.338 69.0581 220.72 61.2102 212.901C53.3623 205.081 64.6566 181.022 86.4368 159.162Z",
    fill: "#ED6A5A"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 172.957,
    cy: 268.089,
    rx: 27.3657,
    ry: 51.506,
    transform: "rotate(-172.62 172.957 268.089)",
    fill: "#E11D05"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53.14,
    height: 112.997,
    rx: 10,
    transform: "matrix(-0.999998 0.00182217 0.00182217 0.999998 145.829 129.783)",
    fill: "#E11D05"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 160.605,
    cy: 306.905,
    rx: 27.3657,
    ry: 51.506,
    transform: "rotate(23.5071 160.605 306.905)",
    fill: "#E11D05"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 221.167,
    cy: 130.933,
    rx: 23.2531,
    ry: 64.2754,
    transform: "rotate(39.2574 221.167 130.933)",
    fill: "#E11D05"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.031,
    cy: 195.99,
    rx: 57.2276,
    ry: 80.2209,
    transform: "rotate(12.9488 162.031 195.99)",
    fill: "#ED6A5A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 176.98,
    cy: 106.834,
    r: 57.2276,
    transform: "rotate(47.8168 176.98 106.834)",
    fill: "#ED6A5A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M223.535 125.767C219.301 146.215 199.292 159.36 178.843 155.126C158.394 150.892 145.25 130.883 149.484 110.434C153.718 89.9852 170.515 92.3513 190.964 96.5853C211.413 100.819 227.769 105.318 223.535 125.767Z",
    fill: "#18191B"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.465,
    cy: 276.051,
    rx: 27.3657,
    ry: 51.506,
    transform: "rotate(-179.878 134.465 276.051)",
    fill: "#ED6A5A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10.2192,
    height: 4.45162,
    rx: 1,
    transform: "matrix(-0.982271 -0.187467 -0.187467 0.982271 213.408 116.139)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 10.2192,
    height: 4.41234,
    rx: 1,
    transform: "matrix(-0.982271 -0.187467 -0.187467 0.982271 182.802 110.319)",
    fill: "white"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 132.541,
    cy: 313.808,
    rx: 27.3657,
    ry: 51.506,
    transform: "rotate(10.4842 132.541 313.808)",
    fill: "#ED6A5A"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.647,
    cy: 173.32,
    rx: 20.0593,
    ry: 55.8735,
    transform: "rotate(-135.104 100.647 173.32)",
    fill: "#ED6A5A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 54.7168,
    y: 49.6064,
    width: 214.943,
    height: 323.096,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpacePersonInflightRed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/space-person-inflight-red.c190fde372de6149d6d00931a392af30.svg";